'use client';

import { useEffect } from 'react';
import { initWebVitals } from '@/lib/services/performance-monitoring';

/**
 * WebVitalsProvider - Initializes Core Web Vitals monitoring
 *
 * This component should be included once in the application root
 * to start collecting performance metrics.
 */
export function WebVitalsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Only initialize in production or when explicitly enabled
    const shouldTrack =
      process.env.NODE_ENV === 'production' ||
      process.env.NEXT_PUBLIC_ENABLE_VITALS === 'true';

    if (shouldTrack) {
      initWebVitals();
    } else if (process.env.NODE_ENV === 'development') {
      // In development, still initialize but with console logging
      initWebVitals();
    }
  }, []);

  return <>{children}</>;
}

export default WebVitalsProvider;
